import type { TFunction } from 'i18next';
import type { ImportIssue } from './onlineImportService';

/**
 * The issue in the person's language, from its code and arguments; the server's English message
 * when the client has no wording for the code. A validation message (`Invalid`) is the server's own,
 * already in the request's language.
 */
export function issueText(issue: ImportIssue, t: TFunction, labelOf: (field?: string | null) => string): string {
  if (issue.code === 'Invalid') return issue.message;
  const key = issue.code === 'NotPermitted'
    ? `onlineImport.issue.NotPermitted.${issue.args.outcome}`
    : `onlineImport.issue.${issue.code}`;
  const text = t(key, { defaultValue: issue.message, ...issue.args, field: labelOf(issue.field) });
  if (text === issue.message) return text;
  const hints = [
    issue.args.transform && t('onlineImport.issue.useTransform', { defaultValue: 'use the {{transform}} transform', transform: issue.args.transform }),
    issue.args.example && t('onlineImport.issue.writtenLike', { defaultValue: 'write it like {{example}}', example: issue.args.example }),
    issue.args.suggestion && t('onlineImport.issue.didYouMean', { defaultValue: 'did you mean “{{suggestion}}”?', suggestion: issue.args.suggestion }),
  ].filter(Boolean);
  return hints.length > 0 ? `${text} — ${hints.join(', ')}` : text;
}
